var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolReferenceLines = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M5.75 14.75h2a.75.75 0 1 0 0-1.5h-2a.75.75 0 1 0 0 1.5M10.75 14.75h2a.75.75 0 1 0 0-1.5h-2a.75.75 0 1 0 0 1.5M15.75 14.75h2a.75.75 0 1 0 0-1.5h-2a.75.75 0 1 0 0 1.5M20.75 14.75h2a.75.75 0 1 0 0-1.5h-2a.75.75 0 1 0 0 1.5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M6.25 10V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3h0M6.25 18.426v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3h0"
}))));
export { SvgToolReferenceLines as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-reference-lines.svg";